/* eslint-disable no-magic-numbers */
export enum PauseDuration {
  OneMonth = 1,
  ThreeMonths = 3,
  SixMonths = 6,
}

export const PAUSE_DURATION_VALUES = Object.values(PauseDuration).filter(
  (value): value is number => typeof value === 'number',
) as PauseDuration[];
